import styled from 'styled-components'
import tw from 'twin.macro'

interface Props {
  isDefaultValue?: boolean
}

const StBaseSelect = styled.select<Props>`
  ${({ isDefaultValue }) => isDefaultValue && tw`text-gray-500 `}
`
export default StBaseSelect
